import { render, staticRenderFns } from "./ShowcaseProjectFilter.vue?vue&type=template&id=3aaaf0de&"
import script from "./ShowcaseProjectFilter.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseProjectFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports